/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MfaToken/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function MfaToken({
  children,
  viewPath = "/App/ChooseLocation/Support/Audit/Content/MfaToken",
  isInvalid,
  onChange
  
}) {
let selectedMfaTokenValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'mfa_token',
})
let selectedMfaTokenIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'mfa_token',
validate: fromValidate.sixDigits,
required: true,
})
let selectedMfaTokenChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'mfa_token',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 marginTop={dtSpaceLs}
 data="selected.mfa_token"
 validate="/Data/validate.js sixDigits"
 invalid={!selectedMfaTokenIsValidData}
 required={true}
 value={selectedMfaTokenValueData}
 onChange={selectedMfaTokenChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Two-factor authentication token"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="sixDigits"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}